var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"our-history"},[_c('div',{staticClass:"our-history__container"},[_c('div',{staticClass:"our-history__title"},[_c('hot-title',{attrs:{"tag":"h2"}},[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),(_vm.image)?_c('hot-image',{attrs:{"src":_vm.image.src,"withoutLazyload":true}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }